import { VcCommunicator } from "./vccommunicator";
import {VcMetadataUtils} from "/src/visualcrossing-core/vcmetadatautils";
import {VcDateUtils} from "/src/visualcrossing-core/vcdateutils";
console.log("VcCommunicatorBulk class")


VcCommunicator.prototype.retrieveStoredDatasetTempLink=function(task) {
    var me=this;
    var config={
    	"taskId":task?task.id:null,
    };
    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("retrievestoreddatasettemplink"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "Link creation failed");
                    return;
                }
                
                resolve(data);
            }).catch(error => {
                reject(error); 
            });
    });
}

VcCommunicator.prototype.constructBulkWeatherDataRequest=function(task, apiKey, downloadAsZip) {
    var me=this;


    downloadAsZip=downloadAsZip || false;
    var url=me.createUrl("retrievebulkdataset");
    var data={
        "sessionId":null,
        "key":null,
    	"taskId":task?task.id:null,
        //"taskResultId":result?result.id:null,
        "zip":downloadAsZip
    };
    
    if (apiKey) {
        data.key=me.sessionState && me.sessionState.apiKey;
    } else {
        data.sessionId=me.sessionId;
    }
    
    data=Object.keys(data).reduce(function(a, d) {
        var v=data[d];
        if (v===null) return a;
        return a+"&"+d+"="+v;
    }, "")

   return url+"?"+data;


}

/**
 * Build a URL for retrieving a formatted (e.g. XLSX) version of a bulk dataset result.
 * Uses the retrieveformatteddataset endpoint which converts stored JSON to the requested format on-the-fly.
 * @param {object} task - The task/metadata object with an id property
 * @param {boolean} apiKey - Whether to authenticate with API key (true) or session (false)
 * @param {string} format - Output format: "xlsx" (default)
 * @returns {string} The formatted download URL
 */
VcCommunicator.prototype.constructFormattedDataRequest=function(task, apiKey, format) {
    var me=this;

    format = format || "xlsx";
    var url=me.createUrl("retrieveformatteddataset");
    var data={
        "sessionId":null,
        "key":null,
    	"taskId":task?task.id:null,
        "format":format
    };
    
    if (apiKey) {
        data.key=me.sessionState && me.sessionState.apiKey;
    } else {
        data.sessionId=me.sessionId;
    }
    
    data=Object.keys(data).reduce(function(a, d) {
        var v=data[d];
        if (v===null) return a;
        return a+"&"+d+"="+v;
    }, "")

   return url+"?"+data;
}

VcCommunicator.prototype.sortResultsByTimeDesc=function(a,b) {
   return VcMetadataUtils.getSafeResultTime(b) - VcMetadataUtils.getSafeResultTime(a) ;
}
VcCommunicator.prototype.processJobPackageResults=function(results) {
    var me=this;
    results && results.forEach(function(taskResults) {
      if (!taskResults || !taskResults.jobPackage ) return; //|| !taskResults.results || !taskResults.results.length
      //me.processJobPackageResultList(taskResults.results, taskResults.jobPackage, taskResults.instance);
      me.processJobPackageResultList(taskResults);
      taskResults.results=taskResults.results && taskResults.results.sort(me.sortResultsByTimeDesc);
      taskResults.jobPackage.results=taskResults.results
      taskResults.jobPackage.instance=taskResults.instance;
    })

}
VcCommunicator.prototype.processJobPackageResultList=function(taskResults) {
    //let results=taskResults.results;
    let jobPackage=taskResults.jobPackage || taskResults.metadata;
   //let instance=taskResults.instance;

    if (taskResults.instance) {
        taskResults.instance.dateTime=VcDateUtils.dateFromIso(taskResults.instance.dateTime);
        taskResults.instance.endDatetime=VcDateUtils.dateFromIso(taskResults.instance.endDatetime);
        taskResults.instance.expirationDateTime=VcDateUtils.dateFromIso(taskResults.instance.expirationDateTime);
        taskResults.results=[taskResults.instance];
    } else {
   
        taskResults.results && taskResults.results.forEach(result => {
            result.runTime=VcMetadataUtils.getTagPrefixValue(result, "RunTime");
            result.dateTime=VcDateUtils.dateFromIso(result.runTime);
            result.taskId=jobPackage && jobPackage.id;
        });
    }
}
VcCommunicator.prototype.resultsByJobPackage=function(id, goal) {
    var me=this;
    var config={
        id:id,
        goal:goal
    };


    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("resultsbyjobpackage"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "b failed");
                    return;
                }
                //console.log("resultsByJobPackage")
                me.processJobPackageResults(data);


                resolve(data);
            }).catch(error => {
                reject(error); 
            });
    });


}

VcCommunicator.prototype.loadBulkSourceDefn=function(id) {
    var me=this;
    var config={
        id:id
    };


    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("loadbulksourcedefn"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "loadbulksourcedefn failed");
                    return;
                }
                
                resolve(data);
            }).catch(error => {
                reject(error); 
            });
    });


}

VcCommunicator.prototype.loadBulkSourceResultDefn=function(id) {
    var me=this;
    var config={
        id:id
    };


    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("loadbulksourceresultdefn"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "loadbulksourceresultdefn failed");
                    return;
                }
                
                resolve(data);
            }).catch(error => {
                reject(error); 
            });
    });


}
VcCommunicator.prototype.saveBulkSourceDefn=function(id,name,desc,defn) {
    var me=this;
    var config={
        id:id,
        name:name,
        desc:desc,
        defn:JSON.stringify(defn),
    };
    //console.log(config);
    
    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("savebulksourcedefn"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "savebulksourcedefn failed");
                    return;
                }

                //me.processJobPackageResultList(data.results, data.metadata, data.instance);
                me.processJobPackageResultList(data);
                resolve(data);
            }).catch(error => {
                reject(error); 
            });
    });
    
}
VcCommunicator.prototype.readBulkProcessData=function(id) {
    var me=this;
    var config={
        id:id
    };
    
    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("readbulkprocesseddata"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "readbulkprocesseddata failed");
                    return;
                }
                
                resolve(data.result);
            }).catch(error => {
                reject(error); 
            });
    });
}
VcCommunicator.prototype.processBulkLocations=function(id,defn) {
    var me=this;

    var config={
        id:id,
        defn:JSON.stringify(defn)
    };
 
    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("processbulklocations"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "processbulklocations failed");
                    return;
                }
                
                resolve(data.result);
            }).catch(error => {
                reject(error); 
            });
    });


}
VcCommunicator.prototype.bulkSourceDataPreview=function(id, callback) {
    var me=this;

    var config={
        id:id
    };
    
    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("bulksourcedatapreview"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "bulksourcedatapreview failed");
                    return;
                }
                
                resolve(data.result);
            }).catch(error => {
                reject(error); 
            });
    });

    
}

VcCommunicator.prototype.uploadBulkLocations=function(metadataId,metadataName, file,rawLocations,callback) {

    var me=this;
    var formData = new FormData();
    if (file) formData.append('file', file);
    if (rawLocations) formData.append('rawLocations', rawLocations);
    if (me.sessionId) {
        formData.append("sessionId",me.sessionId);
    }
    if (metadataId) {
        formData.append("id",metadataId);
    }
    if (metadataName) {
        formData.append("name",metadataName);
    }

    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("uploadbulklocations"), formData, "multipart")
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "uploadbulklocations failed");
                    return;
                }
                
                resolve(data.result);
            }).catch(error => {
                reject(error); 
            });
    });

}

// ============================================
// Sharing API methods
// ============================================

/**
 * Create a new share link for a definition.
 * @param {object} shareConfig - { definitionId, shareType, name, password, allowedUsers, expiresAt }
 * @returns {Promise} resolves with the created share object
 */
VcCommunicator.prototype.createShare=function(shareConfig) {
    var me=this;
    var config={
        definitionId: shareConfig.definitionId,
        shareType: shareConfig.shareType || "weather_risk_monitor",
        name: shareConfig.name || "",
    };
    if (shareConfig.password) config.password = shareConfig.password;
    if (shareConfig.allowedUsers) config.allowedUsers = JSON.stringify(shareConfig.allowedUsers);
    if (shareConfig.expiresAt) config.expiresAt = shareConfig.expiresAt;
    if (shareConfig.notifyOnUpdate) config.notifyOnUpdate = "true";

    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("shares/create"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "Create share failed");
                    return;
                }
                resolve(data);
            }).catch(error => {
                reject(error);
            });
    });
}

/** * List child users for the current authenticated user's account.
 * @returns {Promise} resolves with array of child user objects
 */
VcCommunicator.prototype.listChildUsers=function() {
    var me=this;
    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("childusers/list"), null, null, "GET")
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "List child users failed");
                    return;
                }
                resolve(Array.isArray(data) ? data : []);
            }).catch(error => {
                reject(error);
            });
    });
}

VcCommunicator.prototype.createChildUser=function(email, password, type, label) {
    var me=this;
    var config={
        email: email || "",
        password: password || "",
        type: type || "user",
        label: label || "",
    };
    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("childusers/create"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "Create child user failed");
                    return;
                }
                resolve(data);
            }).catch(error => {
                reject(error);
            });
    });
}

VcCommunicator.prototype.removeChildUser=function(email) {
    var me=this;
    var config={
        email: email,
    };
    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("childusers/remove"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "Remove child user failed");
                    return;
                }
                resolve(data);
            }).catch(error => {
                reject(error);
            });
    });
}

VcCommunicator.prototype.changeChildPassword=function(email, newPassword) {
    var me=this;
    var config={
        email: email,
        newPassword: newPassword || "",
    };
    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("childusers/changeuserpassword"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "Change child password failed");
                    return;
                }
                resolve(data);
            }).catch(error => {
                reject(error);
            });
    });
}

VcCommunicator.prototype.resetChildApiKey=function(email) {
    var me=this;
    var config={
        email: email,
    };
    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("childusers/resetuserapikey"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "Reset child API key failed");
                    return;
                }
                resolve(data);
            }).catch(error => {
                reject(error);
            });
    });
}

/** * List all shares for a definition.
 * @param {string} definitionId - The definition to list shares for
 * @returns {Promise} resolves with { shares: [...] }
 */
VcCommunicator.prototype.listShares=function(definitionId) {
    var me=this;
    var config={
        definitionId: definitionId,
    };

    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("shares/list"), config, null, "GET")
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "List shares failed");
                    return;
                }
                resolve(data);
            }).catch(error => {
                reject(error);
            });
    });
}

/**
 * Update an existing share.
 * @param {object} shareUpdate - { shareId, name, password, clearPassword, allowedUsers, expiresAt, enabled }
 * @returns {Promise} resolves with the updated share object
 */
VcCommunicator.prototype.updateShare=function(shareUpdate) {
    var me=this;
    var config={
        shareId: shareUpdate.shareId,
    };
    if (shareUpdate.name !== undefined) config.name = shareUpdate.name;
    if (shareUpdate.password) config.password = shareUpdate.password;
    if (shareUpdate.clearPassword) config.clearPassword = "true";
    if (shareUpdate.allowedUsers) config.allowedUsers = JSON.stringify(shareUpdate.allowedUsers);
    if (shareUpdate.expiresAt !== undefined) config.expiresAt = shareUpdate.expiresAt;
    if (shareUpdate.enabled !== undefined) config.enabled = shareUpdate.enabled ? "true" : "false";
    if (shareUpdate.notifyOnUpdate !== undefined) config.notifyOnUpdate = shareUpdate.notifyOnUpdate ? "true" : "false";

    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("shares/update"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "Update share failed");
                    return;
                }
                resolve(data);
            }).catch(error => {
                reject(error);
            });
    });
}

/**
 * Delete a share.
 * @param {string} shareId - The share token to delete
 * @returns {Promise} resolves on success
 */
VcCommunicator.prototype.deleteShare=function(shareId) {
    var me=this;
    var config={
        shareId: shareId,
    };

    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("shares/delete"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "Delete share failed");
                    return;
                }
                resolve(data);
            }).catch(error => {
                reject(error);
            });
    });
}

/**
 * Manually send data-updated email notifications.
 * If shareId is provided, sends only for that specific share; otherwise for all notifiable shares of the definition.
 * @param {string} definitionId - The definition to send notifications for
 * @param {string} [shareId] - Optional specific share to send for
 * @returns {Promise} resolves with { success, message }
 */
VcCommunicator.prototype.sendDataUpdateNotification=function(definitionId, shareId) {
    var me=this;
    var config={
        definitionId: definitionId,
    };
    if (shareId) config.shareId=shareId;

    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("shares/sendupdate"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "Send notification failed");
                    return;
                }
                resolve(data);
            }).catch(error => {
                reject(error);
            });
    });
}

/**
 * Get access analytics for a share.
 * @param {string} shareId - The share token
 * @param {number} [limit] - Max number of log entries (default 100)
 * @returns {Promise} resolves with { share, accessLog, summary }
 */
VcCommunicator.prototype.getShareAnalytics=function(shareId, limit) {
    var me=this;
    var config={
        shareId: shareId,
    };
    if (limit) config.limit = limit;

    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("shares/analytics"), config, null, "GET")
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "Get analytics failed");
                    return;
                }
                resolve(data);
            }).catch(error => {
                reject(error);
            });
    });
}

/**
 * Send email notifications to shared users about a share link.
 * @param {object} params - { shareId, userIds }
 * @returns {Promise} resolves with { sentCount } on success
 */
VcCommunicator.prototype.sendShareNotification=function(params) {
    var me=this;
    var config={
        shareId: params.shareId,
    };
    if (params.userIds) config.userIds = JSON.stringify(params.userIds);

    return new Promise((resolve, reject) => {
        me.retrieveData(me.createUrl("shares/notify"), config)
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "Send notification failed");
                    return;
                }
                resolve(data);
            }).catch(error => {
                reject(error);
            });
    });
}

/**
 * Get shared data (public, no auth required). Used in read-only shared view.
 * @param {string} shareId - The share token
 * @param {string} [password] - Password if share is password-protected
 * @param {string} serverRoot - The server root URL
 * @returns {Promise} resolves with { share, data } or { noData: true }
 */
VcCommunicator.prototype.getSharedData=function(shareId, password, serverRoot) {
    var me=this;
    var url = (serverRoot || me.config.serverroot) + "share/" + encodeURIComponent(shareId) + "/data";
    var config = {};
    if (password) config.password = password;

    return new Promise((resolve, reject) => {
        me.retrieveData(url, config, null, "GET")
            .then(data => {
                if (data.errorCode) {
                    reject(data.message || "Get shared data failed");
                    return;
                }
                resolve(data);
            }).catch(error => {
                // The server returns HTTP 401 for password-required shares.
                // retrieveData rejects with the response body text in that case.
                // Try to parse it and resolve if it indicates password is needed.
                if (typeof error === 'string') {
                    try {
                        var parsed = JSON.parse(error);
                        if (parsed && parsed.requiresPassword) {
                            resolve(parsed);
                            return;
                        }
                    } catch (e) {
                        // not JSON, fall through
                    }
                }
                reject(error);
            });
    });
}

/**
 * Build a URL for downloading shared data as XLSX or CSV. (public, no auth required)
 * @param {string} shareId - The share token
 * @param {string} [format] - "xlsx" (default) or "csv"
 * @param {string} [password] - Password if required
 * @param {string} serverRoot - The server root URL
 * @returns {string} The download URL
 */
VcCommunicator.prototype.constructSharedDownloadUrl=function(shareId, format, password, serverRoot) {
    var me=this;
    format = format || "xlsx";
    var url = (serverRoot || me.config.serverroot) + "share/" + encodeURIComponent(shareId) + "/download";
    var params = "format=" + format;
    if (password) params += "&password=" + encodeURIComponent(password);
    return url + "?" + params;
}